const GitHubLogo = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="36"
    height="36"
    viewBox="0 0 36 36"
  >
    <g data-name="Group 1832" transform="translate(-876 -219)">
      <rect
        data-name="Rectangle 1590"
        width="36"
        height="36"
        rx="5"
        transform="translate(876 219)"
        fill="currentColor"
      />
      <path
        d="M12.01,0a12.111,12.111,0,0,0-3.8,23.577c.6.12.815-.26.815-.581,0-.28-.02-1.242-.02-2.244-3.341.721-4.037-1.442-4.037-1.442a3.091,3.091,0,0,0-1.332-1.763c-1.093-.741.08-.741.08-.741a2.519,2.519,0,0,1,1.849,1.242,2.544,2.544,0,0,0,3.5,1,2.578,2.578,0,0,1,.756-1.622c-2.665-.28-5.468-1.322-5.468-5.97A4.737,4.737,0,0,1,5.587,8.213a4.4,4.4,0,0,1,.119-3.205s1.014-.321,3.3,1.242a11.449,11.449,0,0,1,6,0c2.287-1.563,3.3-1.242,3.3-1.242a4.4,4.4,0,0,1,.119,3.205,4.646,4.646,0,0,1,1.233,3.245c0,4.647-2.8,5.669-5.488,5.97a2.873,2.873,0,0,1,.815,2.243c0,1.622-.02,2.925-.02,3.325,0,.321.219.7.815.581A12.111,12.111,0,0,0,12.01,0Z"
        transform="translate(882 225)"
        fill="#fff"
        fillRule="evenodd"
      />
    </g>
  </svg>
);

export default GitHubLogo;
